export const theme = {
  container: {
    width: '100%',
    minHeight: '829',
    backgroundColor: '#ffffff',
  },
  contentMasonry: {
    spacing: '2',
    maxWidth: '1000px',
    margin: '0 auto',
  },
  title: {
    fontSize: 'clamp(0.6rem, calc(1rem + 1.1vw), 2.8rem)',
    color: '#000000',
    textAlign: 'center',
    margin: '20px 0',
  },
  paragraph: {
    fontSize: '1rem',
    textAlign: 'justify',
  },
};
